import { CoordinatorService } from "./coordinator.service"

type TAG = "project-details" | "references"
type TYPE = "table" | "list"

export type RSPAR = {
    tag: TAG
    type: TYPE
    title?: string
}

export class ReportSection {
    tag: TAG
    type: TYPE
    title: string

    constructor(public coords: CoordinatorService, params: RSPAR) {
        this.tag = params.tag
        this.title = params.title || this.tag
        this.type = params.type
    }

    get input() {
        switch (this.tag) {
            case "project-details":
                return this.coords.project$.current
            case "references":
                return this.coords.dataset$.main
        }
    }
}
